import { Box } from "@mui/material";
import { useState } from "react";
import Navbar from "../common/Navbar";
import SideNavbar from "../common/SideNavbar";
import { Outlet } from "react-router-dom";
import useGlobalState from "../Context";
import { logout, setIsLoggedIn } from "../reducer/action";
import { useNotificationContext } from "../common/NotificationContext";

const LoginAuth = () => {
  const [reduxStore, dispatch] = useGlobalState();
  const redirectUrl = process.env.REACT_APP_OAUTH_URL;
  const { showNotification } = useNotificationContext();

  const auth = reduxStore?.auth;
  const [showSideNavbar, setShowSideNavbar] = useState(false);

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
      return null;
    }
  };
  const decodedJwt = parseJwt(auth?.token);
  const isTokenExpired =
    auth?.token && decodedJwt ? decodedJwt.exp * 1000 < Date.now() : false;

  if (isTokenExpired) {
    try {
      dispatch(logout());
      dispatch(setIsLoggedIn(false));
    } catch (err) {
      showNotification("Error", err?.message);
    }
  }
  if (!!auth && !!auth?.token && !isTokenExpired) {
    return (
      <>
        <Box className="App" display={"flex"}>
          <Navbar toggleSideNavbar={setShowSideNavbar} />
          <SideNavbar
            anchor={showSideNavbar}
            toggleSideNavbar={setShowSideNavbar}
          />
          <Outlet />
        </Box>
      </>
    );
  } else {
    window.location.href = redirectUrl;
  }
};

export default LoginAuth;
